import React from 'react';
import { connect } from "react-redux";
import { IContent, IProduct } from '../../../types';
import { ProductPushItem } from '../../../types/content';
import { withContent } from '../../../hoc/withContext';
import './ProductPushElement.scss';
import { cleanSpaces, getProductById, getProductURL, sendEvent } from '../../../utils';

// @ts-ignore
import Fade from 'react-reveal/Fade';

import BackgroundImage from '../../UI/Image/BackgroundImageElement';
import Image from '../../UI/Image/Image';
import Loader from '../Loader/Loader';
import ProductPushPrice from './ProductPushPrice';

interface IProductPushElementProps {
  context?: IContent;
  info: ProductPushItem;
  index: number;
  products?: IProduct[];
}

const ProductPushElement = ({ context, info, products, index }: IProductPushElementProps) => {
  const { global, config } = context;
  const { tracking, image } = info;

  const productId = cleanSpaces(info.product.product_id);
  if (!productId) {
    return null;
  }
  const productFound = getProductById(products, productId, info.product.product_type);

  return (
    <div className="element-product_push">
      <Fade delay={100 * index} duration={600}>
        <BackgroundImage
          classNames={["block-content"]}
          imageName={`bg-triple${index + 1}.jpg`}
          href={getProductURL(productId, config.country_code)}
          onClick={() => sendEvent(tracking)}
          tag="a"
        >
          <span className="bg-image">
            {image && (
              <Image
                imageName={image}
                altText=""
              />
            )}
          </span>
          <span className="price-desktop">
            <ProductPushPrice product={productFound} />
          </span>
          <span className="content">
            <span className="info">
              {!products && !productFound ? (
                <Loader />
              ) : products && productFound ? (
                <>
                  <span className="block-title">{productFound.short_title || productFound.title}</span>
                  <ProductPushPrice product={productFound} />
                  <span className="action">
                    <button
                      className="button buynow"
                      data-alt-text={global.shop}
                    >
                      <span>{global.shop}</span>
                    </button>
                  </span>
                </>
              ) : null}
            </span>
          </span>
        </BackgroundImage>
      </Fade>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.products.data
});

export default connect(mapStateToProps)(withContent(ProductPushElement));
